module.exports = __webpack_public_path__ + "static/media/but_double_arrow.5c108ca6.svg";